export const getStyles = (theme, { variant } = {}) => {
  const isInline = variant === 'inline';

  return {
    // Label always sits on its own line above the value(s).
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    label: {
      fontFamily: 'AvenirNext-DemiBold',
      fontSize: '10px',
      fontWeight: '600',
      color: theme.palette.color.grayMain,
      marginBottom: '3px',
    },
    // Keeps the label text and an optional adornment (e.g. an edit icon) on one line.
    labelWithAdornment: { display: 'flex', alignItems: 'center', gap: '4px' },
    values: {
      display: 'flex',
      flexDirection: isInline ? 'row' : 'column',
      alignItems: isInline ? 'baseline' : 'flex-start',
      flexWrap: isInline ? 'wrap' : 'nowrap',
      columnGap: '6px',
    },
    window: {
      fontFamily: 'AvenirNext',
      fontSize: '10px',
      color: theme.palette.color.black,
    },
  };
};
